import { Component, OnInit, Inject, Input, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import { Notification, NotificationType } from 'src/app/models/NotificationModel';
import { Router } from '@angular/router';
import { SatPopover } from '@ncstate/sat-popover';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'cw-ci-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  @Input() popover:SatPopover;

  constructor(private _sessionService: SessionService, private _platformApi: PlatformApiService, private dialog: MatDialog, private _router: Router, public sessionService: SessionService) { }

  ngOnInit() { }

  display(notification) {
    if (notification.type == NotificationType.INFORMATIONAL || notification.type == NotificationType.MARKETING || notification.type == NotificationType.SYSTEM_ALERT) {
      const dialogRef = this.dialog.open(NotificationComponent, {
        panelClass: 'flush-dialog',
        autoFocus: false,
        data: {
          notification,
          height: 'auto'
        }
      });
      dialogRef.afterClosed().subscribe(markRead => {

        if (markRead != undefined) {
          this._platformApi.saveNotificationStatus(this._sessionService.getCurrentAccount().id, this._sessionService.getCurrentUser().id, notification.id, markRead).subscribe(() => {
            this._sessionService.refreshSessionData();
          });
        }
      });
    } else if (notification.type == NotificationType.NEW_ASSESSMENT || notification.type == NotificationType.COMPLETED_ASSESSMENT || notification.type == NotificationType.COMPLETED_SCAN) {
      this._platformApi.saveNotificationStatus(this._sessionService.getCurrentAccount().id, this._sessionService.getCurrentUser().id, notification.id, true).subscribe(() => {
        this._sessionService.refreshSessionData();
      });
      if (notification.type == NotificationType.NEW_ASSESSMENT) {
        if (this._sessionService.hasFeature('DASHBOARD_ENABLED')) {
          this._router.navigate([`/secured/master/internal/assessments/${notification.referenceIds[1]}`]);
        } else {
          this._router.navigate([`/secured/master/company/assessment/${notification.referenceIds[1]}`]);
        }
      } else if (notification.type == NotificationType.COMPLETED_ASSESSMENT) {
        this._router.navigate([`/secured/master/companies/${notification.referenceIds[0]}/assessment/${notification.referenceIds[1]}`]);
      } else if (notification.type == NotificationType.COMPLETED_SCAN) {
        this._router.navigate([`/secured/master/vulnerabilityScans/scanTargets/${notification.referenceIds[1]}/scanResults/${notification.referenceIds[2]}`]);
      }
      this.popover.toggle();
    }
  }
}

@Component({
  selector: 'cw-ci-notification',
  template: `
<div class="dashboard-tile" style="box-sizing:content-box;">
  <div class="tile-header">
    <div class="tile-header-title">{{notification.subject}}</div>
    <div class="tile-header-action">
      <button mat-icon-button color="primary" (click)='buttonAction()'>
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
  <div class="tile-content">
    <h2>{{notification.subject}}</h2>
    <h3>{{notification.createdAt | date:'short'}}</h3>
    <div style="margin: 0 0 16px;" [innerHtml]='notification.message'></div>
    <div class="tile-footer">
      <button mat-button color="primary" (click)="buttonAction()">Close</button>
      <button mat-raised-button color="primary" *ngIf="!notification.isRead" (click)="buttonAction('MARKREAD')">Mark As Read</button>
      <button mat-raised-button color="primary" *ngIf="notification.isRead"(click)="buttonAction('MARKUNREAD')">Mark As Unread</button>
    </div>
  </div>
</div>
  `,
  styleUrls: ['./notifications.component.scss']
})
export class NotificationComponent implements OnInit {
  notification;
  msgHeight = '400';

  constructor(public dialogRef: MatDialogRef<NotificationComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.notification = data.notification;
    if (data.height) {
      this.msgHeight = data.height;
    }
  }

  ngOnInit() {
  }

  buttonAction(value?: string): void {
    this.dialogRef.close(value == 'MARKREAD');
  }
}